import React from 'react'
import ProductTypeDetailsContent from '../../../components/Dashboard/ProductTypesListContent/View';
import { Link } from 'react-router-dom';

function ProductTypeDetails() {
    return (
        <>
          {/* Breadcrumb */}
          {/* <div className="breadcrumb-card">
            <h5>Product Type Details</h5>
    
            <ul className="breadcrumb">
              <li>
                <Link to="/dashboard/ecommerce/">
                  <i className="material-symbols-outlined">home</i>
                  Dashboard
                </Link>
              </li>
              <li>eCommerce</li>
              <li>Product Types</li>
              <li>Product Types Details</li>
            </ul>
          </div> */}
           
          <ProductTypeDetailsContent />
        </>
      );
}

export default ProductTypeDetails
